import { CustomerServiceOptions } from './types';
import { customerStore } from './customerStore';
import { Store } from 'vuex';
import Vue from 'vue';
import { isNil, isString } from 'lodash';

import { uiBus } from '@/container';

const customerModuleKey = 'step_customer_service';
class CustomerService {
	private store!: Store<any>;
	public init(serviceOptions: CustomerServiceOptions): void {
		Vue.prototype[customerModuleKey] = this;
		this.store = serviceOptions.store;
		this.store.registerModule(customerModuleKey, customerStore);

		if (this.isCustomerSet) {
			const value = this.sessionParsedObject.getOrElse(customer => customer, {} as ICustomer);
			this.setCustomer(value.idCustomer, value.name);
		}
	}

	private get setCustomerEvent() {
		return 'setCustomer';
	}

	getCustomer(): string | null {
		return this.store.getters[`${customerModuleKey}/idCustomer`];
	}

	getCustomerName(): string {
		return this.store.getters[`${customerModuleKey}/customerName`];
	}

	setCustomer(idCustomer: string, name: string): void {
		this.store.commit(`${customerModuleKey}/setIdCustomer`, idCustomer);
		this.store.commit(`${customerModuleKey}/setCustomerName`, name);
		const customer: ICustomer = {
			idCustomer,
			name
		};
		if (!this.inIframe())
			sessionStorage.setItem(customerModuleKey, JSON.stringify(customer));
		uiBus.emit(this.setCustomerEvent, customer);
	}

	private get sessionParsedObject() {
		let rawItem: string | null = null;
		if (!this.inIframe())
			rawItem = sessionStorage.getItem(customerModuleKey);
		return new SessionQueryResult<ICustomer>(rawItem);
	}

	get isCustomerSet() {
		// return this.sessionParsedObject.getOrElse( () => true, false);
		return this.sessionParsedObject.getOrElse( () => true, false) || !isNil(this.getCustomer());
	}

	onCustomerChange(onCustomerChange: (event: ICustomer) => void) {
		uiBus.on(this.setCustomerEvent, onCustomerChange);
	}

	offCustomerChange(onCustomerChange: (event: ICustomer) => void) {
		uiBus.off(this.setCustomerEvent, onCustomerChange);
	}

	private inIframe () {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
	}
}

interface ICustomer {
	idCustomer: string;
	name: string;
}

class SessionQueryResult<T> {
	private rawSessionObject: string | null;
	constructor(rawObject: string | null) {
		this.rawSessionObject = rawObject;
	}

	private get isObjectAvailable() {
		return isString(this.rawSessionObject);
	}

	getOrElse<R>(lambda: (obj: T) => R, elseValue: R): R {
		if (this.isObjectAvailable)
			return lambda(JSON.parse(this.rawSessionObject as string));
		return elseValue;
	}
}

export default new CustomerService();
